var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2357 18.4388L20.1665 18.0884C19.8056 18.046 19.4398 18.086 19.0966 18.2052C18.7534 18.3245 18.4417 18.5201 18.1849 18.7771L15.9615 21.0005C12.5315 19.2556 9.74351 16.4675 7.99861 13.0376L10.234 10.8021C10.7536 10.2826 11.0074 9.55756 10.9228 8.82047L10.5724 5.77547C10.5041 5.18591 10.2213 4.64208 9.77783 4.24765C9.33437 3.85321 8.76127 3.63575 8.16777 3.63672H6.07736C4.71194 3.63672 3.57611 4.77256 3.66069 6.13797C4.30111 16.4571 12.554 24.698 22.8611 25.3384C24.2265 25.423 25.3624 24.2871 25.3624 22.9217V20.8313C25.3744 19.6109 24.4561 18.5838 23.2357 18.4388Z",
    fill: "#274137"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call_icon.a86b2d825bace619426f410fec09f48a.svg";
export { ForwardRef as ReactComponent };